import Dot from 'resources/icons/Dot';

type Props = {
    details: { title: string }[];
};

const DottetList = ({ details }: Props) => (
    <ul>
        {details.map((item, index) => (
            <li
                key={index}
                className="text-14 text-gray-700 pl-4 my-8 flex items-center space-x-12 "
            >
                <Dot />
                <p className="m-0">{item.title}</p>
            </li>
        ))}
    </ul>
);

export default DottetList;
